import React, { useState } from "react";
import usdt__logo from "../assets/img/usdt.png";
import vft__logo from "../assets/img/vft.png";

const StakingCard = () => {
	const [max, setMax] = useState(0);
	const [stake, setStake] = useState("stake");
	const [destribution, setDestribution] = useState("");

	const handleChange = (event) => {
		setStake(event.target.value);
	};
	return (
		<div className="stake--tabs-card bg--section">
			<ul className="stake-tab-top">
				<li>
					<img src={vft__logo} alt="img" />
					<span>STAKE VFT</span>
				</li>
				<li>
					<img src={usdt__logo} alt="img" />
					<span>EARN USDT</span>
				</li>
			</ul>
			<ul className="stake-switch">
				<li>
					<label>
						<input
							type="radio"
							name="stake-check"
							onChange={handleChange}
							value="stake"
							checked={stake === "stake"}
							hidden
						/>
						<span>Stake</span>
					</label>
				</li>
				<li>
					<label>
						<input
							type="radio"
							name="stake-check"
							onChange={handleChange}
							value="unstake"
							hidden
							checked={stake === "unstake"}
						/>
						<span>Unstake</span>
					</label>
				</li>
			</ul>
			<div className={`${stake === "stake" ? "fadeIn" : "d-none"}`}>
				<div className="stake-amount">
					<label className="d-flex flex-wrap justify-content-between mb-2 pb-1">
						<span>Amount To Stake</span>
						<span>Balance : 5000</span>
					</label>
					<div className="stake-amount-group">
						<label htmlFor="number" className="vft">
							VFT
						</label>
						<input
							className="form-control"
							type="number"
							id="number"
							placeholder="Ex: 500"
							value={max}
							onChange={(e) => setMax(e.target.value)}
						/>
						<div className="max-amount" onClick={() => setMax(5000)}>
							Max
						</div>
					</div>
				</div>
				<ul className="cmn--list">
					<li>
						<span>Staking Fee </span>
						<span>50 VFT</span>
					</li>
					<li>
						<span>Reward Token</span>
						<span>USDT</span>
					</li>
				</ul>
				<button
					type="submit"
					className="cmn--btn btn-full-width rounded w-100"
				>
					STAKE
				</button>
				<hr class="stake--hr" />
				<div className="stake-contents">
					<ul className="statistics-list px-0">
						<li>
							<span>Staking Fee</span>
							<span>0.9%</span>
						</li>
						<li>
							<span>VFT Stake Tier</span>
							<span>Tier 2</span>
						</li>
						<li>
							<span>Minimum Stake</span>
							<span>100 VFT</span>
						</li>
						<li>
							<span>Reward Pool</span>
							<span>7,382 USDT</span>
						</li>
					</ul>
					<p>
						Fees will be recalculated on stake according to your VFT
						staking tier, and savings will be rebounced back to your
						wallet
					</p>
				</div>
			</div>
			<div className={`${stake === "unstake" ? "fadeIn" : "d-none"}`}>
				<div className="stake-amount">
					<label className="d-flex flex-wrap justify-content-between mb-2 pb-1">
						<span>Amount To Stake</span>
						<span>Balance : 5000</span>
					</label>
					<div className="stake-amount-group">
						<label htmlFor="number" className="vft">
							VFT
						</label>
						<input
							className="form-control"
							type="number"
							id="number"
							placeholder="Ex: 500"
							value={max}
							onChange={(e) => setMax(e.target.value)}
						/>
						<div className="max-amount" onClick={() => setMax(5000)}>
							Max
						</div>
					</div>
				</div>
				<ul className="cmn--list">
					<li>
						<span>Staking Fee </span>
						<span>50 VFT</span>
					</li>
					<li>
						<span>Reward Token</span>
						<span>USDT</span>
					</li>
				</ul>
				<div className="d-flex align-items-center justify-content-between mb-3">
					<h6 className="text-white">Enable Auto Distribution</h6>
					<label
						className={`form-check form-switch form--switch ${
							destribution ? "checked" : ""
						}`}
					>
						<input
							className="form-check-input"
							type="checkbox"
							value={true}
							checked={destribution}
							onClick={() => setDestribution(!destribution)}
						/>
					</label>
				</div>
				<button
					type="submit"
					className="cmn--btn btn-secondary btn-full-width rounded w-100"
				>
					Withdraw 100 Earning
				</button>
				<button
					type="submit"
					className="cmn--btn btn-full-width rounded w-100"
				>
					UNSTAKE
				</button>
				<hr class="stake--hr" />
				<div className="stake-contents">
					<ul className="statistics-list px-0">
						<li>
							<span>Reward Pool</span>
							<span>7,382 USDT</span>
						</li>
					</ul>
					<p>
						Fees will be recalculated on stake according to your VFT
						staking tier, and savings will be rebounced back to your
						wallet
					</p>
				</div>
			</div>
		</div>
	);
};

export default StakingCard;
